import { AGG_OPTIONS } from "../constants";

export type AggValue = "avg" | "sum" | "best";

/**
 * The aggregations a metric allows. A helmet count has `avg` and `sum` only: the backend
 * rejects `helmet-<id>-best` on save. A metric with no list allows every option.
 */
export function aggOptionsFor(allowed?: readonly string[] | null) {
  return AGG_OPTIONS.filter((a) => !allowed || allowed.includes(a.value)).map((a) => ({
    label: a.label,
    value: a.value,
  }));
}

/** The aggregation to keep after a metric change: the current one, or the first the metric allows. */
export function coerceAgg(agg: AggValue, allowed?: readonly string[] | null): AggValue {
  if (!allowed || allowed.includes(agg)) return agg;
  return (aggOptionsFor(allowed)[0]?.value ?? "avg") as AggValue;
}

/** The `aggregations` list of one option of the grouped metric dropdown, or undefined. */
export function allowedAggsFromDropdown(
  metricDropdown: any[],
  metricId: string | null | undefined,
): string[] | undefined {
  if (!metricId) return undefined;
  for (const group of metricDropdown) {
    const opt = group.options?.find((o: any) => o.value === metricId);
    if (opt) return opt.aggregations;
  }
  return undefined;
}
